import React, { useEffect } from 'react';
import moment from 'moment';
import Loader from 'modules/Common/Loader';
import { ReactComponent as MesageIcon } from 'assets/icons/message-smiling.svg';
import Message from 'modules/chat/Conversation/Message';
import Date from 'modules/chat/Conversation/Date';
import { closedTicketStatuses } from 'modules/chat/Conversation/constants';
import { Button } from '@ontruck/orc';

const t = {
  create: 'Create new conversation',
  loading: 'Loading messages',
  closed: 'Conversation is closed and cannot be reopened',
};

function renderMessagesAndDates(messages) {
  const lastMessageReadByDriver = messages.reduce((total, currentMessage) => {
    if (
      (currentMessage.sender.agent || currentMessage.sender.name === 'Ontruck') &&
      currentMessage.read_by_driver === true
    ) {
      return currentMessage;
    }
    return total;
  }, 0);

  return messages.map((message, i, arr) => {
    const isFirst = i === 0;
    const prevMessage = arr[i - 1] || {};
    const currentMessageDay = moment(message.created_at).startOf('day');
    const prevMessageDay = moment(prevMessage.created_at).startOf('day');
    const renderDate = isFirst || currentMessageDay.isAfter(prevMessageDay);
    return (
      <>
        {renderDate && <Date date={currentMessageDay} />}
        <Message
          key={message && `${i}_${message.created_at}`}
          sender={message && message.sender}
          message={message && message.message}
          timestamp={message && message.created_at}
          attachments={message && message.attachments}
          read_by_driver={message && message.read_by_driver}
          last_read_by_driver_at={message && message.last_read_by_driver_at}
          message_id={message && message.id}
          last_message_read_by_driver={lastMessageReadByDriver && lastMessageReadByDriver.id}
        />
      </>
    );
  });
}

const MessageList = ({
  messages,
  className,
  loading,
  isStarted,
  handleCreateConversation,
  status,
}) => {
  const endOfListRef = React.createRef();

  // Keep scroll position to the last message of the list.
  useEffect(() => {
    if (!!endOfListRef.current && !!endOfListRef.current.scrollIntoView) {
      endOfListRef.current.scrollIntoView();
    }
  }, [endOfListRef, messages]);

  return (
    <div data-testid="messagelist" className={className}>
      {loading && (
        <div className="loading">
          <Loader text={t.loading} skin="white" />
        </div>
      )}
      {!isStarted && !loading && (
        <div className="not-started">
          <MesageIcon />
          <p>The conversation with this driver hasn't started yet.</p>
          <Button
            noWrap
            skin="grey"
            disabled={loading}
            text={t.create}
            onClick={handleCreateConversation}
          />
        </div>
      )}

      {isStarted && !loading && (
        <>
          {renderMessagesAndDates(messages)}
          {closedTicketStatuses.includes(status) && <div className="closed"> {t.closed}</div>}
          <div ref={endOfListRef} />
        </>
      )}
    </div>
  );
};

export default MessageList;
